import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CompleteApplicationRoutingModule } from './complete-application-routing.module';
import { CompleteApplicationComponent } from './complete-application/complete-application.component';
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { ProfessionalDetailsComponent } from './professional-details/professional-details.component';
import { MatCardModule } from "@angular/material/card";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogModule} from "@angular/material/dialog";
import { AdditionalDetailsComponent } from './additional-details/additional-details.component';
import { SharedModule } from "../shared/shared.module";
import { SkipPopupComponent } from './skip-popup/skip-popup.component';
import { CompleteApplicationService } from '../services/complete-application.service';
import { SharedServiceService } from '../services/shared-service.service';
import { AddCardFeaturesComponent } from './add-card-features/add-card-features.component';

export const MaterialModuleArr = [
  MatCardModule,
  MatGridListModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
  MatCheckboxModule,
  MatButtonModule,
  MatChipsModule,
  MatDialogModule,
  MatStepperModule,
  MatIconModule,
  MatExpansionModule,
  MatSliderModule,
  MatDatepickerModule,
  MatTooltipModule, 
];

@NgModule({
  declarations: [
    CompleteApplicationComponent,
    PersonalDetailsComponent,
    ProfessionalDetailsComponent,
    AdditionalDetailsComponent,
    SkipPopupComponent,
    AddCardFeaturesComponent,
  ],

  imports: [
    CommonModule,
   // CompleteApplicationRoutingModule,
    MaterialModuleArr,
    SharedModule,
    FormsModule,
    ReactiveFormsModule

  ],
  
  entryComponents: [
    SkipPopupComponent,
  ],

  exports: [
    MaterialModuleArr,
    SkipPopupComponent,
    
  ],
  providers: [
    CompleteApplicationService,
    { provide: APP_BASE_HREF, useValue: window.location.pathname },
  ]
  
})
export class CompleteApplicationModule { }
